export const customColors = {
  facebook: {
    '50': { value: '#f5f8fb' },
    '100': { value: '#d6e2ed' },
    '200': { value: '#b2c8de' },
    '300': { value: '#87a9cc' },
    '400': { value: '#00468d' },
    '500': { value: '#00468d' },
    '600': { value: '#003264' },
    '700': { value: '#115599' },
    '900': { value: '#003366' },
  },
  brand: {
    blue: { value: 'hsla(210, 100%, 29%, 1)' },
    lightGray: { value: '#EDEFF1' },
    black: { value: '#2C2C2C' },
    warning: { value: '#FFA200' },
    green: {
      '50': { value: '#E8FCF3' },
      '100': { value: '#C0F7DC' },
      '200': { value: '#97F2C6' },
      '300': { value: '#6EEDB0' },
      '400': { value: '#45E79A' },
      '500': { value: '#1DE283' },
      '600': { value: '#17B569' },
      '700': { value: '#11884F' },
      '800': { value: '#0B5B35' },
      '900': { value: '#062D1A' },
    },
  },
}
